// 2FA Actions
export const GET_2FA = 'USER/GET_2FA'
export const SET_2FA = 'USER/SET_2FA'
export const RESET_2FA = 'USER/RESET_2FA'
export const ENABLE_2FA = 'USER/ENABLE_2FA'
export const DISABLE_2FA = 'USER/DISABLE_2FA'
export const INIT_2FA = 'USER/INIT_2FA'
